import { $t } from "@/lib/i18nHelpers";
import { FormFields, ListField } from "@/types";

export const systemName = "other";

export const listField: ListField = { value: systemName, text: $t("Other") };

export const formFields: FormFields = [
  {
    name: "details",
    label: $t("Details"),
    type: "textarea",
    placeholder: $t("A convenient way for you to withdraw money and details for the operation"),
    autoGrow: true,
    rows: 3,
    rules: ["required"],
    validationMode: "aggressive",
  },
];
